module.exports = __webpack_public_path__ + "img/0603-o.8cfe1900.svg";